module.exports = __webpack_public_path__ + "img/健康预警机器人ppt-7.41e6c615.jpg";